import { Exercice } from 'src/types';

/**
 * @french
 * État initial du slice des exercices.
 */
export const exercicesInitialState = {
  activeExercices: [] as Exercice[],
  selectedDateRange: null as [Date | null, Date | null] | null,
  selectedDateRangePeriod1: null as [Date | null, Date | null] | null,
  selectedDateRangePeriod2: null as [Date | null, Date | null] | null,
  secondaryActiveExercices: [] as Exercice[],
};

/**
 * @french
 * Type dérivé de l’état initial.
 */
export type ExercicesState = typeof exercicesInitialState;
